import React from "react";

import { srcPath } from "../util/Path";
import { minRatio } from "../util/Constants";

interface Props {
  ratio: number;
  scale: number;
  left: number;
}

const RotateNotice = (props: Props) => {
  const { ratio, scale, left } = props;

  const isShown = ratio < minRatio;

  const style = {
    display: isShown ? "block" : "none",
    width: window.innerWidth / scale,
    left: `${left}px`,
  };

  return (
    <div className="please-rotate" style={style}>
      <div className="please-rotate-container">
        <img
          className="please-rotate-container__img"
          src={srcPath("shared/rotate.png")}
          alt=""
        />
      </div>
    </div>
  );
};

export default RotateNotice;
